import React from 'react'
import styles from './styles.module.css'
import caretDown from '../../../../img/caretDownGeneric.svg'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../images/circle-info-regular-full.svg'


function MostRecentRentalPrice ({ localRentalPrice, setLocalRentalPrice }) {
  const handleRentalPriceValueChange = event => {
    const { name, value } = event.target
    const re = /^[0-9\b]+$/
    if (value === '' || re.test(value)) {
      setLocalRentalPrice(prevState => ({
        ...prevState,
        [name]: value,
        currency: prevState.currency || 'USD'
      }))
    }
  }

  const handleRentalCurrencyChange = event => {
    const { value } = event.target
    setLocalRentalPrice(prevState => ({
      ...prevState,
      currency: value
    }))
  }

  return (
    <div className={styles.mostRecentRentalPriceContainer}>
      <div className={styles.inlineLabel}>
        <span className={styles.mostRecentRentalPriceSpan}>
          Most Recent Price Amount
        </span>
        <Tooltip
          title='Filter by the most recent rental price range. Enter a minimum, maximum, or both.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Rental price help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div className={styles.mostRecentRentalPriceInputGroup}>
        <input
          autoComplete='off'
          className={styles.mostRecentRentalPriceInput}
          placeholder='Min'
          onChange={handleRentalPriceValueChange}
          value={localRentalPrice.minValue}
          name='minValue'
        />

        <input
          autoComplete='off'
          className={styles.mostRecentRentalPriceInput}
          placeholder='Max'
          onChange={handleRentalPriceValueChange}
          value={localRentalPrice.maxValue}
          name='maxValue'
        />
        <div className={styles.mostRecentRentalPriceSelectContainer}>
          <select
            className={styles.mostRecentRentalPriceSelect}
            onChange={handleRentalCurrencyChange}
            value={localRentalPrice.currency}
            name='currency'
          >
            <option value='USD'>USD</option>
            <option value='CAD'>CAD</option>
            {/* Add more currency options here */}
          </select>
          <img
            src={caretDown}
            alt='arrow'
            className={styles.mostRecentRentalPriceArrow}
          />
        </div>
      </div>
    </div>
  )
}

export default MostRecentRentalPrice
